import { getString } from "config-api";

export const LINEUP_ID = getString(
    "Client.contentApi.contentList.lineupIds.news/multi-lineup-listing"
);
export const DATA_URL = `${LINEUP_ID}`;

export const MULTI_LINEUP_NEWS = [
    {
        title: "Canada",
        link: "/news/canada",
        lineupID: "newscanada",
        lineupSlug: "news-canada",
        categorySlug: "news-canada",
    },
    {
        title: "World",
        link: "/news/world",
        lineupID: "newsworld",
        lineupSlug: "news-world",
        categorySlug: "news-world",
    },
    {
        title: "Business",
        link: "/news/business",
        lineupID: "newsbusiness",
        lineupSlug: "news-business",
        categorySlug: "news-business",
    },
    {
        title: "Politics",
        link: "/news/politics",
        lineupID: "newspolitics",
        lineupSlug: "news-politics",
        categorySlug: "news-politics",
    },
    {
        title: "Entertainment",
        link: "/news/entertainment",
        lineupID: "newsentertainment",
        lineupSlug: "news-entertainment",
        categorySlug: "news-entertainment",
    },
    {
        title: "Science",
        link: "/news/science",
        lineupID: "newsscience",
        lineupSlug: "news-science",
        categorySlug: "science",
    },
    {
        title: "Health",
        link: "/news/health",
        lineupID: "newshealth",
        lineupSlug: "news-health",
        categorySlug: "news-health",
    },
    {
        title: "Indigenous",
        link: "/news/indigenous",
        lineupID: "newsindigenous",
        lineupSlug: "news-indigenous",
        categorySlug: "news-indigenous",
    },
];
